import _ from "lodash";
import { hogesTheme } from "themes/hoges";

const specificNoordhoffThemeProperties = {
  name: "hogesNoordhoff",
  palette: {
    primary: {
      brand: "#5F84FF",
      _900: "#4A6ACC",
      _700: "#3A54A3",
      _400: "#2A3E7A",
      _200: "#1A2852",
    },
    secondary: {
      brand: "#339580",
      _900: "#2A7A66",
      _700: "#22604F",
      _400: "#194738",
      _200: "#102F22",
    },
  },
};

export const hogesNoordhoffTheme = _.merge({}, hogesTheme, specificNoordhoffThemeProperties);
